import Amplify, { Auth } from "aws-amplify";

class SignOps {
  constructor() {
    this.region = 'us-east-1';
    this.userPoolId = '';
    this.clientSecret = '';

    this.username = '';
    this.password = '';
    this.jwt = '';
    this.configured = false;
    this.signedIn = false;
  }

  configure(region, userPoolId, clientSecret) {
    this.region = region;
    this.userPoolId = userPoolId;
    this.clientSecret = clientSecret;

    Amplify.configure({
      Auth: {
        region: this.region,
        userPoolId: this.userPoolId,
        userPoolWebClientId: this.clientSecret,
      },
      API: {
        endpoints: [
          {
            name: "theApi",
            endpoint: "https://k9jzcca0z7.execute-api.us-east-1.amazonaws.com/dev",
          },
        ],
      },
    });
    this.configured = true;
  }

  setData(username, password) {
    this.username = username;
    this.password = password;
  }

  requireConfigure(inner_fn, ...args) {
    if (this.configured) {
      return inner_fn(...args);
    }

    const error = { message: 'Not configured yet.' };
    return new Promise((resolve, reject) => reject(error));
  }

  requireSignedIn(inner_fn) {
    if (this.signedIn) {
      return inner_fn();
    }
    const error = { message: 'Not signed in yet.' };
    return new Promise((resolve, reject) => reject(error));
  }

  signUp = () => this.requireConfigure(() => {
    return Auth.signUp({
      username: this.username,
      password: this.password,
    });
  });

  signIn = async () => this.requireConfigure(async () => {
    try {
      const user = await Auth.signIn(this.username, this.password);
      console.info('signIn user: ', user);
      if(user.challengeName === 'NEW_PASSWORD_REQUIRED') {
        return Promise.reject({ user, message: 'NEW_PASSWORD_REQUIRED' });
      }
      this.jwt = user.signInUserSession.idToken.jwtToken;
      this.signedIn = true;
      return Promise.resolve(user);
    } catch (error) {
      console.error("Error signing in: ", error);
      return Promise.reject(error);
    }
  });

  signOut = () => this.requireSignedIn(() => {
    return Auth.signOut();
  });

  forgotPassword = () => this.requireConfigure(() => {
    return Auth.forgotPassword(this.username);
  });

  changePassword = (user, password) => this.requireConfigure(() => {
    return Auth.completeNewPassword(user, password, {});
  });

  resendCode = () => this.requireConfigure(() => {
    return Auth.resendSignUp(this.username);
  });

  confirmForgotPassword = code => this.requireConfigure(code => {
    return Auth.forgotPasswordSubmit(this.username, code, this.password);
  }, code);

  confirmSignup = code => this.requireConfigure(code => {
    return Auth.confirmSignUp(this.username, code);
  }, code);

  getJwt = () => this.requireSignedIn(() => {
    return new Promise((resolve, reject) => {
      const meta = document.createElement("textarea");
      document.body.appendChild(meta);
      meta.value = this.jwt;
      meta.select();
      document.execCommand("copy");
      document.body.removeChild(meta);
      resolve({ JWT: this.jwt });
    });
  });
}

class GetJwtApp {
  constructor() {
    this.signOps = new SignOps();
  }
}

export default GetJwtApp;
